import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=4cf6ec60&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=4cf6ec60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6ec60",
  null
  
)

export default component.exports